import { NgModule } from "@angular/core";

import { TrimWhitespaceToHyphenDirective } from "./trim-whitespace-hyphen.directive";

const DIRECTIVES = [TrimWhitespaceToHyphenDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class TrimWhitespaceToHyphenModule {}
